<template>
    <div class="stat-container mb-2">
        <div class="row my-2 px-3">
            <div class="col-2">
                <font-awesome-icon
                    icon="chart-line"
                    class="stat-icon dont-print"
                />
            </div>
            <div class="col-2">
                <span class="stat-title">{{ $t('orders.total_geometry_distance') }}</span>
                <span class="stat-text">{{ totalGeometryDistance.toFixed(2) }}</span>
            </div>
            <div class="col-2">
                <span class="stat-title">{{ $t('orders.total_driving_distance') }}</span>
                <span class="stat-text">{{ totalRoadDistance.toFixed(2) }} km</span>
            </div>
        </div>
    </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";

export default {
    name: 'OrderGeometrySummary',
    mixins: [timeUtils],
    props: {
        totalGeometryDistance: {
            type: Number,
            default: 0
        },
        totalRoadDistance: {
            type: Number,
            default: 0
        },
    },

}

</script>
